import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo1.png';

export default function header2() {
    return (
        <>
            <div>
                <Container>
                    <Row className="align-items-center">
                        <Col>
                            <div>
                                <Link to="/">
                                    <img src={logo} alt="logo" className="logo" />
                                </Link>
                            </div>
                        </Col>
                        <Col>

                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}
